import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { Event, EventResponse } from 'src/app/models/core/event.model';

@Injectable({
  providedIn: 'root'
})
export class EventApiService {
  private baseUrl = `${environment.api_server}/api`;

  constructor(
    private _http: HttpClient,
    private _api: ApiService
  ) { }

  private buildParams(
    page?: number,
    limit?: number,
    query?: string,
    business_id?: number
  ): HttpParams {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('per_page', String(limit ?? 10));

    if (query) params = params.set('q', query);
    if (business_id) params = params.set('business_id', String(business_id));

    return params;
  }

  public getUpcomingEventsBySeller(
    page?: number,
    limit?: number,
    query?: string,
    business_id?: number
  ): Observable<EventResponse> {
    const url = `${this.baseUrl}/seller-app/events`;
    const params = this.buildParams(page, limit, query, business_id);
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.get<EventResponse>(url, { headers, params })
      )
    );
  }

  public getPastEventsBySeller(
    page?: number,
    limit?: number,
    query?: string,
    business_id?: number
  ): Observable<EventResponse> {
    const url = `${this.baseUrl}/seller-app/events/past`;
    const params = this.buildParams(page, limit, query, business_id);
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.get<EventResponse>(url, { headers, params })
      )
    );
  }

  public getInactiveEventsBySeller(
    page?: number,
    limit?: number,
    query?: string,
    business_id?: number
  ): Observable<EventResponse> {
    const url = `${this.baseUrl}/seller-app/events/inactive`;
    const params = this.buildParams(page, limit, query, business_id);
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.get<EventResponse>(url, { headers, params })
      )
    );
  }

  public getEventById(
    eventId: number | string,
    with_permissions = false,
    with_config = false
  ): Observable<Event> {
    const url = `${this.baseUrl}/sellers/events/${eventId}`;

    const params = new HttpParams()
      .set('with_permissions', String(with_permissions))
      .set('with_config', String(with_config));

    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.get<{ data: Event }>(url, { headers, params })
      ),
      switchMap(response => [response.data])
    );
  }

}
